import axios from 'axios';


const API_URI = 'https://do8x9ojywa.execute-api.ca-central-1.amazonaws.com/dev'
const DOCS_URI = API_URI + '/api/v0/docs'


export default {

  getTest () {
    return axios.get(API_URI + '/api/v0/test');
  },

  // body: {'trashit': true}
  putDoc (url_hash, body) {
    // let pdMsg = `putDoc (${url_hash}) starting..`;
    // console.log('pdMsg');
    let doc_uri = `${DOCS_URI}/${url_hash}`;
    // return axios.put(doc_uri, body);
    const config = {
      method: 'put',
      url: doc_uri,
      data: body,
      // headers: {
      //   'User-Agent': 'WebUI',
      //   'Access-Control-Allow-Origin': '*'
      // }
    }
    return axios(config);
  },

  // const entry_obj = {
  //   'trashit': false,
  //   'loveit': false,
  //   'source': 'webui',
  //   'text': msg,
  // }
  postDoc (entry_obj) {
    console.log(entry_obj);
    // commit('extendPending', entry_obj);

    const config = {
      method: 'post',
      url: DOCS_URI,
      data: entry_obj,
      // headers: {
      //   'User-Agent': 'WebUI',
      //   'Access-Control-Allow-Origin': '*'
      // }
    }
    return axios(config);
  },

  getSentiment (url_hash) {
    let sentiment_uri = `${API_URI}/api/v0/sentiment/${url_hash}`
    return axios.get(sentiment_uri);
  },

}
